import {_, React, observer, observable, computed, action, useLocalStore, classNames} from '@api'
import {FormControlLabel, FormGroup, Switch, SwitchClassKey, SwitchProps} from '@material-ui/core'
import {} from '@blueprintjs/core'
import {useCatalog} from '@stores'
import {} from '@modules'
import {SmallSwitch} from 'centric-ui-components'
import * as css from './CatalogActiveItemsFilterToggles.css'

/// region Store

export class CatalogActiveItemsFilterTogglesStore {
  constructor() {
  }

  @observable mustHaveAtLeastOneObservable = true
}

export const CatalogActiveItemsFilterTogglesStoreContext = React.createContext<CatalogActiveItemsFilterTogglesStore>(null)
export const useCatalogActiveItemsFilterTogglesStore = () => React.useContext(CatalogActiveItemsFilterTogglesStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const CatalogActiveItemsFilterToggles = observer<MyProps>(function CatalogActiveItemsFilterToggles({className, ...props}) {
  const store = useLocalStore(() => new CatalogActiveItemsFilterTogglesStore()),
    {features: {toolbarSwitches}, _fieldByName, labelForField, settings, filter: { isToolbarFilterSwitchSelected}} = useCatalog()

  if (_.isEmpty(toolbarSwitches)) return null

  return (
    <CatalogActiveItemsFilterTogglesStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>
        <FormGroup row className={css.activeSwitches}>
          {toolbarSwitches.map(config => {
            const {label, field} = config,
              f = _fieldByName[field],
              checked = isToolbarFilterSwitchSelected(config)

            if (!f && !field.endsWith('.images')) {
              console.log(`No such field for toolbar item ${f}`)
              return null
            }

            return (
              <FormControlLabel
                className={css.switchAndLabel}
                key={field}
                label={label || labelForField(f, '', 'singular', true)}
                control={<SmallSwitch checked={checked}
                                 onChange={() => settings.toolbarSwitches[field] = !checked}
                                 color='secondary'
                                 size='small'/>}
              />)
          })}
        </FormGroup>
      </div>
    </CatalogActiveItemsFilterTogglesStoreContext.Provider>)
})

import {withStyles, Theme, createStyles} from '@material-ui/core/styles'

interface Styles extends Partial<Record<SwitchClassKey, string>> {
  focusVisible?: string;
}

interface IOSProps extends SwitchProps {
  classes: Styles;
}

const IOSSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 42,
      height: 26,
      padding: 0,
      margin: theme.spacing(1)
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(16px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: '#52d869',
          opacity: 1,
          border: 'none'
        }
      },
      '&$focusVisible $thumb': {
        color: '#52d869',
        border: '6px solid #fff'
      }
    },
    thumb: {
      width: 24,
      height: 24
    },
    track: {
      borderRadius: 26 / 2,
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: theme.palette.grey[50],
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border'])
    },
    checked: {},
    focusVisible: {}
  })
)(({classes, ...props}: IOSProps) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked
      }}
      {...props}
    />
  )
})
/// endregion



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/topBar/components/CatalogActiveItemsFilterToggles.tsx